import { render, staticRenderFns } from "./Tip.vue?vue&type=template&id=ffcd3432&scoped=true&"
import script from "./Tip.vue?vue&type=script&lang=js&"
export * from "./Tip.vue?vue&type=script&lang=js&"
import style0 from "./Tip.vue?vue&type=style&index=0&id=ffcd3432&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffcd3432",
  null
  
)

export default component.exports